import { PROXY_DISPLAY_NAME } from '../constants/labels';

/**
 * 作成者の表示名を取得する
 * 代理操作の場合は「事務局」と表示
 * @param userName - ユーザー名（nullやundefinedの場合あり）
 * @param isProxy - 代理操作フラグ
 * @returns 表示名
 */
export const getDisplayName = (userName: string | null | undefined, isProxy?: boolean): string => {
  if (isProxy) {
    return PROXY_DISPLAY_NAME;
  }
  return userName || '不明';
};

/** 非正規化保存するアップロード者情報（#3343）。 */
export interface UploaderFields {
  uploadedByUid: string;
  uploadedByName: string;
  uploadedByIcon: string | null;
  isProxy: boolean;
  operatorId: string | null;
}

/**
 * マスタ・辞書に保存するアップロード者情報を組み立てる（#3343）。
 *
 * 代理ログイン中は表示名を「事務局」にし、アイコンは保存しない（null）。
 * 一覧は is_proxy を見て事務局アイコン（hi-story-icon.png）を出すため、
 * 運営スタッフのアイコンURLを残す必要がない。
 *
 * uid は監査のため運営スタッフのものをそのまま保存し、代理の事実は
 * is_proxy / operator_id に残す。
 *
 * なお代理ログインは company_id だけを対象企業へ向け替える作りで、UID は
 * 運営スタッフのままになるため、uploadedByUid と operatorId は同値になる。
 * 冗長だが results / patterns / sub_patterns / ocr_usage_monthly が同じ
 * 3点セット（is_proxy / operator_id / operator_role）を持つため形を揃える。
 *
 * 表示側でも getDisplayName を通すが、保存時に置換しておくことで
 * CSV 出力など getDisplayName を経由しない経路でも実名が漏れない。
 *
 * @param user - 操作中のユーザー（代理中は運営スタッフ）
 * @param isProxy - 代理ログイン中か
 * @param operatorId - 代理操作した運営スタッフの UID
 */
export const buildUploaderFields = (
  user: { uid?: string; name?: string | null; icon?: string | null },
  isProxy: boolean,
  operatorId: string | null,
): UploaderFields => ({
  uploadedByUid: user.uid || '',
  uploadedByName: isProxy ? PROXY_DISPLAY_NAME : user.name || '',
  uploadedByIcon: isProxy ? null : user.icon || null,
  isProxy,
  operatorId: isProxy ? operatorId : null,
});
